import { render, staticRenderFns } from "./ModalImportFile.vue?vue&type=template&id=2b69ea4a&scoped=true"
import script from "./ModalImportFile.vue?vue&type=script&lang=js"
export * from "./ModalImportFile.vue?vue&type=script&lang=js"
import style0 from "./ModalImportFile.vue?vue&type=style&index=0&id=2b69ea4a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b69ea4a",
  null
  
)

export default component.exports